import { openBlock, createElementBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  fill: "none",
  viewBox: "0 0 19 19"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [
    createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.667",
      d: "M9.167 12.5V9.167m0-3.334h.008M17.5 9.167a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0"
    }, null, -1)
  ])]);
}
const InfoIcon = { render };
export {
  InfoIcon as default,
  render
};
//# sourceMappingURL=info.svg.js.map
